import script from "./TableSolo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableSolo.vue?vue&type=script&setup=true&lang=ts"

import "./TableSolo.vue?vue&type=style&index=0&id=b9fc1c8a&lang=scss"

const __exports__ = script;

export default __exports__